import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Modernproperty() {
  return (
    <section className="modern_property p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="order-2 order-md-1 mt-3 mt-md-0"
          >
            <StaticImage
              src="../../../images/solution/real-estate-updated/modern-property.webp"
              alt="tekrevol_web"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={585}
              height={558}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="order-1 order-md-2 my-auto"
          >
            <h2>
              Real Estate App Development Services for{" "}
              <span>Modern Property</span> Solutions
            </h2>
            <p>
              We help you build a customized real estate mobile app to attract
              more clients, drive sales, and enhance your revenue.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Get Started!
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Modernproperty;
